import { createStyles, makeStyles, Theme } from '@material-ui/core';

const styles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      paddingTop: theme.spacing(20),
      paddingBottom: theme.spacing(20),
    },
    table: {
      marginTop: theme.spacing(2),
      overflow: 'auto',
    },
    sortIcon: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    topLevelReportCell: {
      textAlign: 'left',
      paddingLeft: theme.spacing(2),
    },
    categoryReportCell: {
      textAlign: 'left',
      paddingLeft: theme.spacing(5),
    },
    subcategoryReportCell: {
      textAlign: 'left',
      paddingLeft: theme.spacing(10),
    },
    stickyColumn: {
      position: 'sticky',
      left: 0,
      zIndex: 3,
      backgroundColor: theme.palette.background.paper,
    },
  }),
);

export default styles;
